<template>
    <!--明细记录-->
    <div class="layout-right"ref="layout-right">
        <div class="layout-right-top">
            <RightTop bread="连锁管理-明细记录"></RightTop>
        </div>
        <div class="layout-right-body">
            <!--内容区域-->
            <div class="tab-box">
                <el-tabs v-model="onTab">
                    <el-tab-pane label="收银记录" name="cash">
                        <!--收银记录-->
                        <ChainCashHistory />
                    </el-tab-pane>
                    <el-tab-pane label="会员绑定" name="bind">
                        <!--会员绑定-->
                        <ChainStoreBindHistory />
                    </el-tab-pane>
                    <el-tab-pane label="会员积分" name="score">
                        <!--会员积分-->
                        <ChainScoreHistory />
                    </el-tab-pane>
                </el-tabs>

            </div>

        </div>
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    import ChainCashHistory from "@/model/Chain/ChainCashHistory";
    import ChainStoreBindHistory from "@/model/Chain/ChainStoreBindHistory";
    import ChainScoreHistory from "@/model/Chain/ChainScoreHistory";
    export default {
        name: "ChainHistory",
        components: {ChainScoreHistory, ChainStoreBindHistory, ChainCashHistory, RightTop},
        data(){
            return {
                onTab: "cash"
            };
        },
        mounted: function () {
            this.$store.commit("setMenuId", "14-3");
        },
        methods: {
            //切换tab
            switchTab(name){
                this.onTab = name;
            }
        }
    }
</script>

<style scoped>
    .tab-box{
        background-color: #ffffff;
        position: relative;
        padding: 16px;
    }
</style>
